// extracted by mini-css-extract-plugin
module.exports = {"ToggleGroupButton":"ToggleGroupButton_ToggleGroupButton__1MFR6","switchButton":"ToggleGroupButton_switchButton__rhDSQ","activeButton":"ToggleGroupButton_activeButton__C16SM"};